module.exports = __webpack_public_path__ + "img/fruit_watermelon.8be06189.png";